/**
 * @description Checks if a suggestion entry should be shown based on the real value and the form value.
 */
export function shouldShowSuggestionEntry({
  value,
  formValue,
}: {
  value?: string;
  formValue?: string;
}): boolean {
  return !!value && value !== formValue;
}
